import { keys, merge, omit, omitBy, isObject, zipObject } from 'lodash'
import URLSearchParams from '@/utils/URLSearchParams'
import productConfigs from '@/products'
import initClientQuotation from '@/products/clientQuotation'

const CHANGE_STATE = 'changeState'
const SET_IS_OPERATOR = 'setIsOperator'
const SET_IS_EMPLOYEE = 'setIsEmployee'

const mutations = {
  [CHANGE_STATE] (state, payload) {
    state = payload
  },
  [SET_IS_OPERATOR] (state, payload) {
    state.isOperator = payload
  },
  [SET_IS_EMPLOYEE] (state, payload) {
    state.isEmployee = payload
  }
}

const actions = {
  async initApp ({ rootState, state, dispatch, commit }) {
    try {
      // Check if checkout store exists; if not, initialize it as empty object
      const sessionStorageCheckout = JSON.parse(window.sessionStorage.getItem('semprebem:checkout')) || {}

      rootState.urlParams = URLSearchParams()

      if (rootState.urlParams.quotation) {
        rootState.isLoading = true

        await initClientQuotation(rootState.urlParams.quotation)
        await dispatch('getProduct')

        rootState.isLoading = false
      } else if (keys(sessionStorageCheckout).length === 0) {
        await dispatch('getProduct')
      } else {
        await commit(CHANGE_STATE, merge(rootState, sessionStorageCheckout))
      }

      if (!state.isOperator && !state.isEmployee) {
        await dispatch('payment/getPaymentMethodsOptions')
      }
    } catch (error) {
      this._vm.$sentry.logWithContext({
        level: 'error',
        tags: {
          app_step: rootState.steps.currentStep,
          app_errorZone: 'initApp'
        },
        ctx: {
          label: '[ConfigApp] - initApp',
          sessionStorageProduct: window.sessionStorage.getItem('semprebem:product') || null,
          sessionStorageCheckout: window.sessionStorage.getItem('semprebem:checkout') || null
        },
        error
      })
    }
  },
  getProduct ({ rootState, commit }) {
    // Product data via session
    const sessionStorageProduct = JSON.parse(sessionStorage.getItem('semprebem:product'))

    // Load specific configurations for product, except alias (duplicated entry removed)
    const productBasicData = zipObject(
      Object.keys(omit(productConfigs(), ['configs.alias'])),
      Object.values(omit(productConfigs(), ['configs.alias']))
    )

    // Product base object allow split object into store specific module
    const productData = omitBy(sessionStorageProduct, item => {
      isObject(item)
    })

    merge(productData, productBasicData)

    // Initial checkout store feed
    const checkoutData = {
      product: productData,
      plan: {
        ...sessionStorageProduct.plan,
        default: sessionStorageProduct.default,
        promo: sessionStorageProduct.promo
      }
    }

    if (checkoutData.plan.promoCode.applied) {
      checkoutData.promoCode = {
        commission: checkoutData.plan.commission,
        activated: true,
        asyncPending: false,
        valid: true
      }
    }

    if (sessionStorageProduct.personalData) {
      checkoutData.personalData = sessionStorageProduct.personalData
    }

    if (sessionStorageProduct.address) {
      checkoutData.address = sessionStorageProduct.address
    }

    checkoutData.isConfigApp = true

    commit(CHANGE_STATE, merge(rootState, checkoutData))
  }
}

export default {
  mutations,
  actions
}
